exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tasks-body{width:100%;background:#fff;max-height:300px;overflow-y:scroll;overflow-x:hidden}", "", {"version":3,"sources":["d:/packages/vue-uploader/src/components/list.vue"],"names":[],"mappings":"AACA,YAAY,WAAY,gBAAiB,iBAAkB,kBAAmB,iBAAmB,CAChG","file":"list.vue","sourcesContent":["\n.tasks-body{width: 100%;background: #fff;max-height: 300px;overflow-y: scroll;overflow-x: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a0f43c0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/list.vue
// module id = 68
// module chunks = 0